import { createContext, useContext, useMemo } from 'react'

const FilterMenuScrollBehaviorContext = createContext({
  closeOnPageScroll: true,
  pullLeft: undefined,
  fullScreen: false,
})

export const FilterMenuScrollBehaviorProvider = ({
  closeOnPageScroll,
  pullLeft,
  fullScreen = false,
  children,
}) => {
  const value = useMemo(
    () => ({
      closeOnPageScroll: closeOnPageScroll ?? true,
      pullLeft,
      fullScreen,
    }),
    [closeOnPageScroll, pullLeft, fullScreen],
  )
  return (
    <FilterMenuScrollBehaviorContext.Provider value={value}>
      {children}
    </FilterMenuScrollBehaviorContext.Provider>
  )
}

export const useFilterMenuScrollBehavior = () => useContext(FilterMenuScrollBehaviorContext)
